import { useEffect, useState } from "react";

function loadAllModeValues(escuts_modeName: string): Record<string, boolean> {
  const storedModeValues = localStorage.getItem(escuts_modeName);
  return storedModeValues != null ? JSON.parse(storedModeValues) : {};
}

export function useMode(
  escuts_modeName: string,
  dayString: string,
  defaultValue: boolean
): [boolean, (modeValue: boolean) => void] {
  const [modeValue, setModeValue] = useState<boolean>(defaultValue);

  useEffect(() => {
    setModeValue(loadAllModeValues(escuts_modeName)[dayString] ?? defaultValue);
  }, [dayString, defaultValue, escuts_modeName]);

  useEffect(() => {
    const allModeValues = loadAllModeValues(escuts_modeName);
    localStorage.setItem(
      escuts_modeName,
      JSON.stringify({
        ...allModeValues,
        [dayString]: modeValue,
      })
    );
  }, [dayString, escuts_modeName, modeValue]);

  return [modeValue, setModeValue];
}
